import { render, staticRenderFns } from "./editsound.vue?vue&type=template&id=0fd1b69b&scoped=true"
import script from "./editsound.vue?vue&type=script&lang=js"
export * from "./editsound.vue?vue&type=script&lang=js"
import style0 from "./editsound.vue?vue&type=style&index=0&id=0fd1b69b&prod&scoped=true&lang=css"
import style1 from "./editsound.vue?vue&type=style&index=1&id=0fd1b69b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1b69b",
  null
  
)

export default component.exports